import React, { useEffect } from "react";
import StandardTemplate from "../../../templates/standard_template/standard_template";
import FixAndFlipPage1 from "../../../components/loan_tools/fix_and_flip/fix_and_flip_page1";
import FixAndFlipPage2 from "../../../components/loan_tools/fix_and_flip/fix_and_flip_page2";
import FixAndFlipPage3 from "../../../components/loan_tools/fix_and_flip/fix_and_flip_page3";
import FixAndFlipPage4 from "../../../components/loan_tools/fix_and_flip/fix_and_flip_page4";
import FixAndFlipPrintHeader from "../../../components/loan_tools/fix_and_flip/fix_and_flip_print_header";
import "../../../components/loan_tools/fix_and_flip/css/fix_and_flip.scss";

export default function FixAndFlipPrintAllRoute() {
  useEffect(() => {
    const timer = setTimeout(() => window.print(), 800);
    return () => clearTimeout(timer);
  }, []);

  // Print All flows as ONE continuous document: the full letterhead (logo +
  // client + LO + date) once at the top, then each page's content with a slim
  // title-bar divider. We intentionally do NOT force a page break between pages —
  // forcing each page onto a fresh sheet left the bottom of the previous sheet
  // blank (and sometimes a lone header/subtotal on a near-empty sheet). Letting
  // it flow fills every sheet top-to-bottom; the title bars (which avoid breaking
  // across sheets) still mark where each page begins.
  return (
    <StandardTemplate className="fix-and-flip-template fix-and-flip-print-all">
      <div className="fix-and-flip">
        <FixAndFlipPrintHeader pageTitle="Page 1 of 4 — Borrower, Property & Loan Officer Info" />
        <FixAndFlipPage1 />

        <div className="ff-print-all-page-title">
          Fix and Flip Estimator — Page 2 of 4 — Costs: Kitchen &amp; Bedrooms
        </div>
        <FixAndFlipPage2 />

        <div className="ff-print-all-page-title">
          Fix and Flip Estimator — Page 3 of 4 — Additional Repairs, Financing &amp; Summary
        </div>
        <FixAndFlipPage3 />

        <div className="ff-print-all-page-title">
          Fix and Flip Estimator — Page 4 of 4 — Seller Net Sheet &amp; Investor Return
        </div>
        <FixAndFlipPage4 />
      </div>
    </StandardTemplate>
  );
}
